
  import React from "react"
  import Component from "/home/bashdev7/Repositories/mayadpost/src/layouts/index.js"
  import data from "/home/bashdev7/Repositories/mayadpost/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js